import { useContext, useState } from "react";
import { AccountFlagWithState } from "../AccountState";
import { useRemoveAccountFlag } from "../../../../sdk/ams/account/UseRemoveAccountFlag";
import { useRefreshAccountId } from "../../../../sdk/ams";
import { AccountContext } from "../../AccountContext";
import { useFormatAndSendFlagRequest } from "../hooks/useUpsertFlag";
import { toFormattedDate } from "../../../../utilities/FormatHelpers";
import DatePicker from 'react-datepicker';
import "./FlagList.css";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { LoadingWrapper } from "../../../tms/components/LoadingWrapper";
import { useUpsertAccountFlag } from "../../../../sdk/ams/account/UseUpsertAccountFlag";

const CAN_EDIT = true;
export default function FlagList(props: {title: string, flags: AccountFlagWithState[], color?: string, activeFlags: boolean}) {
    const [editing, setEditing] = useState<string>();
    const [minExpiryDate, setMinExpiryDate] = useState<Date | undefined>(new Date());

    const { accountId, billingDate } = useContext(AccountContext);
    const refreshAccount = useRefreshAccountId(accountId);

    const {
        mutateAsync: removeAccountFlag,
    } = useRemoveAccountFlag();

    const onRemove = async (id) => { 
        await removeAccountFlag({accountId, key: id});
        refreshAccount();
    }

    const EffectiveDate = (props: {accountFlag: AccountFlagWithState,  editingRow: string}) => {
      const flag = props.accountFlag;
      if(props.editingRow != flag.key) return <td width={'20%'}>{toFormattedDate(flag.effectiveDate) ?? 'Effective date not set'}</td>
      return <td width={'20%'} >
        <div className="ui form static" style={{position: 'static'}}>
        <Controller
          name="effectiveDate"
          control={formContext.control}
          render={({ field }) => (
            <DatePicker
                name="effectiveDate"
                selected={field.value}
                onChange={(date) => {
                  if(date) {
                    setMinExpiryDate(date)
                  }
                  field.onChange(date);
                }}
                minDate={billingDate}
                dateFormat="dd/MM/yyyy"
                placeholderText="Effective date"
                isClearable={true}
            />
            )}
          />
        </div>
        </td>
    }

    const ExpiryDate = (props: {flag: AccountFlagWithState, editingRow: string}) => {
      const flag = props.flag;
      if(props.editingRow != flag.key) return <td width={'20%'}>{flag.expiryDate?.length ? toFormattedDate(flag.expiryDate) :  'Expiry date not set'}</td>
      return <td width={'20%'} >
        <div className="ui form static" style={{position: 'static'}}>
        <Controller
          name="expiryDate"
          control={formContext.control}
          render={({ field }) => (
            <DatePicker
                name="expiryDate"
                selected={field.value}
                onChange={(date) => {
                  field.onChange(date);
                }}
                minDate={minExpiryDate}
                dateFormat="dd/MM/yyyy"
                placeholderText="Expiry date"
                isClearable
            />
            )}
          />
        </div>
      </td>
    }

    const formContext = useForm<{
      key: string;
      effectiveDate?: string;
      expiryDate?: string;
    }>();
    const { mutateAsync: upsertAccountFlag, isPending } = useUpsertAccountFlag();

    const onUpdateTreatment = useFormatAndSendFlagRequest(accountId, upsertAccountFlag, refreshAccount);
    
    return ( 
        <LoadingWrapper loading={isPending}>
            <div className="flag-list-title"><h2 className="ui header">{props.title}</h2>
            </div>
            {!props.flags?.length && <p className="no-flags">No {props.activeFlags ? 'active' : 'pending'} flags</p>}

            {props.flags?.length > 0 && (
              <div className="scrollable" style={{maxHeight: 1000}}>
                <table className={"ui single line table " + props.color}>
                  <thead className="">
                    <tr>
                      <th style={{ width: '25%' }}>Name</th>
                      <th>Effective date</th>
                      <th>Expiry date</th>
                      <th style={{ width: '10%' }}>Actions</th>
                    </tr>
                  </thead>

                  <tbody>
                    {props.flags.map((flag) => (
                      <tr key={flag.key}>
                        {editing != flag.key && 
                        <>
                          <td className="large"><h5>{flag.key}</h5></td>
                          <EffectiveDate accountFlag={flag} editingRow={null} />
                          <ExpiryDate flag={flag} editingRow={null} />
                        </>
                        }
                        { editing == flag.key &&
                        <>
                        <FormProvider {...formContext}>
                            <td className="large"><h5>{flag.key}</h5></td>
                            <EffectiveDate accountFlag={flag} editingRow={!props.activeFlags ? editing : null} />
                            <ExpiryDate flag={flag} editingRow={editing} />
                        </FormProvider>
                        </>}
             
                        <td>
                            {(editing != flag.key && CAN_EDIT) && <button className="ui button blue" 
                              onClick={() => {
                                formContext.setValue("key", flag.key);
                                if(!props.activeFlags && flag.effectiveDate) formContext.setValue("effectiveDate", new Date(flag.effectiveDate) as any);
                                if(flag.expiryDate) {
                                  formContext.setValue("expiryDate", new Date(flag.expiryDate) as any);
                                }
                                setEditing(flag.key)
                                }}>Edit</button>}
                             {editing && editing == flag.key && <button className="ui button red" 
                            onClick={async () => {
                              setEditing(null)
                              formContext.reset();
                              }}>Cancel</button>}
                            {editing && editing == flag.key && <button className="ui button green"
                              onClick={() => {
                                formContext.handleSubmit(onUpdateTreatment)();
                                setEditing(null);
                              }}
                            >Save</button>}
                            {!editing && <button className="ui button red" onClick={() => onRemove(flag.key)}>Remove</button>}
                        </td>
                      </tr>
                    ))}
                    </tbody>
                </table>
                </div>
            )}
        </LoadingWrapper>
      
 )   
        
}